import faker from 'faker';
import { useFormat } from '@ideavivat/vivat-2';

export default {
  types: {
    _primaryControls: {
      width: '3rem',
    },
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
    },
    name: {
      name: 'ชื่อแหล่งเรียนรู้',
      width: '1fr',
    },
    groupAddress: {
      key: 'province',
      name: 'จังหวัด',
      width: '1fr',
      filter: (val: string | object) => ((typeof val === 'string') ? val : ''),
    },
    contactTelephone: {
      name: 'เบอร์ติดต่อ',
      width: '7rem',
      mock: ['000-000-0000'],
      class: 'text-right',
    },
    lastUpdatedBy: {
      name: 'ผู้แก้ไขข้อมูล',
      width: '10rem',
    },
    updatedAt: {
      name: 'แก้ไขล่าสุด',
      width: '9rem',
      class: 'text-right',
      filter(val: any) {
        return useFormat.date(val).displayShortThaiDate();
      },
    },
    _secondaryControls: {
      width: '5rem',
      class: 'text-right',
    },
  },
  columns: ['_primaryControls', '_increment', 'name', 'groupAddress', 'contactTelephone', 'lastUpdatedBy', 'updatedAt', '_secondaryControls'],
  sortable: ['groupAddress', 'name', 'contactTelephone', 'updatedAt'],
};
